import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={78}
      height={78}
      viewBox="0 0 78 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M76.248 55.149l-26.63-44.896c-4.783-8.074-16.453-8.074-21.252 0L1.752 55.149c-4.89 8.226 1.051 18.647 10.618 18.647h53.26c9.567 0 15.508-10.42 10.618-18.647zM39 63.863a5.715 5.715 0 01-5.713-5.713A5.715 5.715 0 0139 52.437a5.715 5.715 0 015.713 5.713A5.715 5.715 0 0139 63.863zm5.865-36.365l-.7 16.514a5.16 5.16 0 01-5.378 4.936 5.144 5.144 0 01-4.936-4.936l-.7-16.514a5.876 5.876 0 015.56-6.17 5.876 5.876 0 016.17 5.56c0 .214 0 .412-.016.61z"
        fill="#FD4760"
      />
    </Svg>
  );
}

export default SvgComponent;
